export enum WeekDayType {
  SUNDAY = 'SUNDAY',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
}

export enum WeekDayOffType {
  WEEKLY_EVERY = 'WEEKLY_EVERY',
  WEEKLY_INTERVAL = 'WEEKLY_INTERVAL',
}
